import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { PURCHASE_ORDER_WORKFLOW_TRANSITIONS } from '@/configs/purchase-order-workflow-transitions';
import {
  GET_PURCHASE_ORDER_KEY,
  GET_PURCHASE_ORDERS_KEY,
  SEND_PURCHASE_ORDER_KEY,
} from '@/keys';

export type SendPurchaseOrderParams = {
  id: string;
  recipients: string[];
  message: string;
  warehouseId: number;
};

const sendPurchaseOrder = async ({
  id,
  recipients,
  message,
  warehouseId,
}: SendPurchaseOrderParams): Promise<void> => {
  await api.post(`/purchase-orders/${id}/update-status`, {
    recipients,
    message,
    warehouseId,
    transitionName: PURCHASE_ORDER_WORKFLOW_TRANSITIONS.SEND_PURCHASE_ORDER,
  });
};

export const useSendPurchaseOrder = (): UseMutationResult<
  void,
  Error,
  SendPurchaseOrderParams
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: SEND_PURCHASE_ORDER_KEY,
    mutationFn: sendPurchaseOrder,
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({
        queryKey: [...GET_PURCHASE_ORDER_KEY, id],
      });
      queryClient.invalidateQueries({
        queryKey: GET_PURCHASE_ORDERS_KEY,
      });
    },
  });
};
